<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h1 class="align">Términos y condiciones</h1>
        </div>
    </div>
    <br>
    <div class="row justify-text">
        <p class="arial">De conformidad con la Ley Nº 18.331 de Protección de Datos Personales y Acción de Habeas Data,
            de 11 de agosto de 2008 (LPDP), los datos suministrados quedarán incorporados en la base de datos y
            serán utilizados exclusivamente por el Instituto Nacional de Semillas (INASE). </p>

        <p class="arial">Los datos personales serán tratados con el grado de protección adecuado, tomándose las medidas de
            seguridad necesarias para evitar su alteración, pérdida, tratamiento o acceso no autorizado por parte 
            de terceros.
        </p>
        <p class="arial">El responsable de la base de datos es INASE y la dirección donde el titular podrá ejercer los derechos
            de acceso, rectificación, actualización, inclusión o supresión es Cno. Bertolotti s/n y Ruta 8 Km 29,
            Barros Blancos, Canelones, Uruguay.</p>
    </div>
    <!-- <button mat-raised-button (click)="onVolver()">Volver</button> -->
</div>